<template>
    <v-layout row justify-center>
        <v-dialog
                v-model="dialog"
                :value="false"
                lazy
                max-width="600px"
        >
            <v-card>

                <v-card-title>
                    <span class="headline">Solicitar {{specialSaleId ? 'Promoción' : 'Presupuesto'}}</span>
                    <v-btn width="30" absolute right fab flat color="accent" small @click="dialog=false">
                        <v-icon>clear</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <div class="loading-container">
                    <v-progress-linear
                            v-show="loading"
                            color="black"
                            height="2"
                            :indeterminate="true"
                            class="ma-0"
                    ></v-progress-linear>
                </div>

                <v-card-text>
                    <v-container pa-1>
                        <v-layout justify-center>
                            <v-flex xs12 text-xs-center v-if="done">
                                <v-avatar size="75" color="grey lighten-3">
                                    <v-icon size="50" color="green lighten-2">fas fa-check</v-icon>
                                </v-avatar>
                                <h1 class="mt-4 headline green--text">¡Listo!</h1>
                                <h4 class="subtitle mt-2 ">Hemos enviado tu solicitud</h4>
                                <h4 class="subtitle mt-1 grey--text">Recibirás en tu correo {{specialSaleId ? 'las instrucciones para acceder a la promoción': 'el presupuesto solicitado'}}</h4>
                                <v-flex xs12 mt-2>
                                    <v-btn depressed color="primary" dark round @click="dialog=false">Aceptar</v-btn>
                                </v-flex>
                            </v-flex>
                            <div v-else>
                                <v-flex xs12 text-xs-center v-if="!serviceId && !specialSaleId">

                                    <h3>¿Qué servicio(s) deseas cotizar?</h3>
                                    <div class="mt-3"></div>
                                    <service-picker
                                            :service-provider-id="serviceProviderId"
                                            v-on:change="onServiceChange"
                                            v-on:loaded="wait=false"
                                            :default="null"
                                            multiple
                                            required
                                    ></service-picker>

                                </v-flex>

                                <div class="mb-1"></div>

                                <v-flex xs12 text-xs-center>
                                    <div class="mb-3"  :value="!wait && !serviceId && !specialSaleId">
                                        <h3>Necesitamos tus datos para {{specialSaleId ? 'inscribirte en la promoción' : 'generar el presupuesto'}}:</h3>
                                    </div>
                                    <user-or-create
                                            v-on:before-send="loading=true"
                                            v-on:success="sendRequest"
                                            v-on:error="onError"
                                            :facebook-login="false"
                                            :disabled="loading"
                                            :simple="true"
                                            :wait="loading || wait"
                                    ></user-or-create>
                                </v-flex>
                            </div>
                        </v-layout>
                    </v-container>
                </v-card-text>

                </v-card>

        </v-dialog>
    </v-layout>
</template>

<script>
    import UserOrCreate from '@/components/account/UserOrCreate'
    import ServicePicker from './ServicePicker'

    import {mapState, mapMutations} from 'vuex'

    import {ApiUtils} from '@/utils/ApiUtils'

    export default{
        components: { UserOrCreate, ServicePicker },
        props: ['show', 'serviceId', 'serviceProviderId', 'specialSaleId'],
        data(){
            return {
                dialog: this.show || false,
                loading: false,
                done: false,
                wait: this.specialSaleId ? false : true,
                selectedServices: []
            }
        },
        mounted(){},
        methods:{
            ...mapMutations(['showSnackBar']),
            onServiceChange(services){

                if(services.length){
                    this.selectedServices = services.map((service,index) => {
                        return service.id
                    })
                }
            },
            onError(){



                var vm = this
                vm.loading = false

            },
            async sendRequest(user){

                var vm = this
                var payload

                if(!vm.serviceId && vm.selectedServices.length == 0 && !vm.specialSaleId){
                    vm.loading = false
                    vm.showSnackBar('Debes seleccionar al menos 1 servicio')
                    return
                }

                if(vm.serviceProviderId && (vm.serviceId || vm.selectedServices.length)){
                    payload = {
                        service_items_ids: vm.serviceId ? [vm.serviceId] : vm.selectedServices,
                        service_provider_id: vm.serviceProviderId
                    }
                }else if(vm.specialSaleId){
                    payload = {
                        special_sale_id: vm.specialSaleId
                    }
                }else{
                    vm.loading = false
                    vm.showSnackBar('Ocurrió un error inesperado')
                    console.error('quotation request: missing service or special sale params')
                    return
                }

                if(!vm.user.is_data_complete){
                    payload.user = user
                }

                vm.loading = true
                const response = await ApiUtils.makePost('quotations/request', payload)
                if(!vm.user.is_data_complete){
                    await ApiUtils.fetchMe()
                }
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message)
                    return
                }

                vm.done = true

            }
        },
        computed:{
                ...mapState(['currentUser'])
        },
        watch:{
            show(newVal){
                this.dialog = newVal
            },
            specialSaleId(val){
                this.wait = !val
            },
            dialog(newVal){
                if(newVal && this.currentUser){
                    this.user = this.currentUser
                }
                this.$emit('change', newVal)
            }
        }
    }
</script>

<style scoped>

    >>>.v-dialog.v-dialog--active{
        margin: 5px 24px;
        max-height: 95%;
    }

    .loading-container{
        height:2px
    }

    .limit-alert{
        background-color: rgba(255,255,255,.9);
        border-radius: 5px;
        border: 1px solid #ccc;
        padding: 10px;
    }
</style>